"use client";
import React from "react";

import { useCheckoutContext } from "@stadium/checkout/src/contexts/checkout";
import CurrencySelector from "@stadium/ui/src/components/currency-selector";

const CheckoutCurrencySelector = (props) => {
  const { currencies, currency, setCurrency } = useCheckoutContext();
  return <CurrencySelector
    {...props}
    currencies={currencies}
    currency={currency}
    setCurrency={setCurrency}
  />
}

export default CheckoutCurrencySelector;
